import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-database-zap-icon',
  templateUrl: 'database-zap-icon.component.html'
})
export class DatabaseZapIconComponent {
  constructor() {}
}
